import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Dialog, Transition } from "@headlessui/react";
import Image from "next/image";
import DropdownMenu from "./common/DropdownMenu";
import Button from "./common/Button";
import Store from "../utils/Store";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useStoreState } from "pullstate";
import UserIcon from "./common/UserIcon";
import { filter, get, isEmpty, map } from "lodash";
import classNames from "classnames";
import { useRouter } from "next/router";
import Link from "next/link";
import useCheckWorklistContainer from "../hooks/useCheckWorklistContainer";
import { getCurrentRegion, getIsLoggedIn, getUrlAuthToken, isIOSWebView, isWebView } from "../utils";
import Modal from "./common/Modal";
import redirectToLogin from "../utils/redirectToLogin";
import useMedia, { MediaSizes } from "../hooks/useMedia";
import useCheckDashboardContainer from "../hooks/useCheckDashboardContainer";
import { faAlignJustify, faAngleLeft, faArrowRightFromBracket, faBell, faChevronLeft, faCircleUser, faGear, faList, faNetworkWired, faUserGroup, faUsersMedical, faXmark, faHandshake, faArrowUpArrowDown, faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { faFileArrowUp, faShareNodes, faMobileNotch } from "@fortawesome/pro-light-svg-icons";
import AwesomeIcon from "./AwesomeIcon";
import { useTranslation } from "react-i18next";
import { PatientsContext } from "./Patients/PatientsContext";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
import constants from "../utils/constants";
import { patientsExportService } from "./ExportMessage/services/downloadService";
import Tooltip from "./NotificationWidget/Tooltip";
import getPatients from "./Patients/services/getPatients";
import { subscribeUserNotification } from "../utils/pushNotification";
import useAuthService from "../hooks/useAuthService";
import Loader from "./Loader";
import Toggle from "./common/Toggle";
import useSaveNotificationSettings from "./NotificationSettings/hooks/useSaveNotificationSettings";
import Toast from "./Toast";
import { GatewayContext } from "./GatewayIndicator/GatewayContext";
import GatewayDropdown from "./GatewayIndicator/GatewayDropdown";
import servicesUtils from "../utils/servicesUtils";
var PDS_EXPORT_CSV_URL = "recist/exportdata/";
var Menubar = function Menubar(_ref) {
  var _window, _filter$, _window2, _activePatientDetail$, _activePatientDetail$2, _ref5, _activePatientDetail$3;
  var onToggleThemeClick = _ref.onToggleThemeClick;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(false),
    isStartingDownload = _useState2[0],
    setDownloadExport = _useState2[1];
  var _useState3 = useState(false),
    showSwiftFilter = _useState3[0],
    setShowSwiftFilter = _useState3[1];
  var _useState4 = useState(false),
    isSubscribeLoading = _useState4[0],
    setSubscribeLoading = _useState4[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        swiftModeEnabled: s.swiftModeEnabled
      };
    }),
    swiftModeEnabled = _useStoreState.swiftModeEnabled;
  var _useState5 = useState(false),
    showTermsAndConditionsModal = _useState5[0],
    setShowTermsAndConditionsModal = _useState5[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var router = useRouter();
  var params = get(router, ["query", "params"], []);
  var patient_uid = params && params.length ? Number((params === null || params === void 0 ? void 0 : params.length) > 1 ? params === null || params === void 0 ? void 0 : params[1] : params === null || params === void 0 ? void 0 : params[0]) : "";
  var hideMenubar = !!patient_uid && get(router, ["route"], "").includes("/patients/");
  var isWorkList = useCheckWorklistContainer();
  var isDashboard = useCheckDashboardContainer();
  var _useContext = useContext(PatientsContext),
    patientsData = _useContext.patientsData,
    setLastId = _useContext.setLastId,
    getFilterParams = _useContext.getFilterParams,
    filters = _useContext.filters,
    count = _useContext.count,
    setFilters = _useContext.setFilters;
  var _useAuthService = useAuthService(false),
    refetchProfile = _useAuthService.refetch,
    isProfileLoading = _useAuthService.isFetching;
  var saveNotificationSettings = useSaveNotificationSettings();
  var _patientsData = get(patientsData, ["data", "content"], []);
  var _patientsUID = map(_patientsData, "patient_uid");
  var isNotificationSettings = get(router, ["pathname"], "").includes("notification-settings");
  var isGatewayIndicator = get(router, ["pathname"], "").includes("gateway-indicator");
  var isPatientRegistration = get(router, ["pathname"], "").includes("patient-registration");
  var _useContext2 = useContext(GatewayContext),
    offlineGatewayCount = _useContext2.offlineGatewayCount,
    totalGateway = _useContext2.totalGateway;
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var isViewerPage = (!isWorkList && !isDashboard || isNotificationSettings || isGatewayIndicator) && !isPatientRegistration;
  var _useStoreState2 = useStoreState(Store, function (store) {
      return {
        user: store.user,
        userInfo: store.userInfo,
        patient: store.patient,
        isGetFullAccessOpen: store.isGetFullAccessOpen,
        currentPatient: store.patientDetail,
        isDarkMode: store.isDarkMode,
        isRNTestBuild: store.isRNTestBuild,
        RNSelectedEnv: store.RNSelectedEnv,
        isExportReady: store.isExportReady,
        downloadProgress: store.downloadProgress,
        exportGenFailed: store.exportGenFailed,
        RNfcmToken: store.RNfcmToken,
        fcmToken: store.fcmToken,
        isNotificationSubscribing: store.isNotificationSubscribing
      };
    }),
    user = _useStoreState2.user,
    patient = _useStoreState2.patient,
    isExportReady = _useStoreState2.isExportReady,
    userInfo = _useStoreState2.userInfo,
    downloadProgress = _useStoreState2.downloadProgress,
    exportGenFailed = _useStoreState2.exportGenFailed,
    isGetFullAccessOpen = _useStoreState2.isGetFullAccessOpen,
    isDarkMode = _useStoreState2.isDarkMode,
    isRNTestBuild = _useStoreState2.isRNTestBuild,
    RNSelectedEnv = _useStoreState2.RNSelectedEnv,
    RNfcmToken = _useStoreState2.RNfcmToken,
    fcmToken = _useStoreState2.fcmToken,
    isNotificationSubscribing = _useStoreState2.isNotificationSubscribing;
  var metabase_enabled = get(userInfo, ["metabase_enabled"], false);
  var isLoggedIn = getIsLoggedIn();
  var activePatientDetail = (_filter$ = filter(_patientsData, ["patient_uid", patient_uid])[0]) !== null && _filter$ !== void 0 ? _filter$ : {};
  var page_size = get(patientsData, ["data", "page_size"]);
  var indexOfCurrentPatient = _patientsUID.indexOf(patient_uid);
  var hasPatientDetails = !isEmpty(activePatientDetail) || !isEmpty(patient);
  var token = RNfcmToken || fcmToken;
  var hasPermission = isMobileApp && !!RNfcmToken || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Notification) === null || _window2 === void 0 ? void 0 : _window2.permission) === "granted";
  var isSubscribed = isNotificationSubscribing || !isLoggedIn && hasPermission || !token && hasPermission || get(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return get(tokenObj, ["token"], "") === token;
  });
  var isNotificationOn = !isLoggedIn || !get(userInfo, ["settings", "notification_snoozed"], false);
  var urlAuthToken = getUrlAuthToken();
  useEffect(function () {
    if (localStorage.getItem(constants.PERSISTED.isSwiftReportModeEnabled)) {
      Store.update(function (s) {
        s.swiftModeEnabled = true;
      });
    } else {
      Store.update(function (s) {
        s.swiftModeEnabled = false;
      });
    }
  }, []);
  useEffect(function () {
    if (indexOfCurrentPatient === _patientsUID.length - 2 && page_size === 10) {
      setLastId(_patientsUID[_patientsUID.length - 1]);
    }
  }, [indexOfCurrentPatient]);
  var handleChangeButton = function handleChangeButton(type) {
    if (indexOfCurrentPatient !== -1) {
      if (type === "next" && indexOfCurrentPatient !== _patientsData.length) {
        router.replace("/viewer/quredicom/".concat(_patientsUID[indexOfCurrentPatient + 1]));
      } else if (indexOfCurrentPatient !== 0) {
        router.replace("/viewer/quredicom/".concat(_patientsUID[indexOfCurrentPatient - 1]));
      }
    } else {
      var _filterParams = getFilterParams(filters);
      var _params2 = _objectSpread(_objectSpread({
        page_size: 1
      }, _filterParams), {}, {
        pagination_id: get(router, ["query", "params", 1]),
        page: type
      });
      getPatients(_params2, {}).then(function (_patientsData) {
        router.replace("/viewer/quredicom/".concat(get(_patientsData, ["data", "first_id"])));
      })["catch"](function (e) {
        console.log("err", e);
      });
    }
  };
  var onBack = function onBack() {
    if (isIOSWebView()) {
      router.back();
    } else {
      router.replace("/patients/".concat(patient_uid));
    }
    Store.update(function (s) {
      s.swiftModeEnabled = false;
    });
    localStorage.removeItem(constants.PERSISTED.isSwiftReportModeEnabled);
    if (swiftModeEnabled) {
      setFilters(constants.DEEFAULT_FILTER);
    }
  };
  var onUpdateSubscription = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _window3, _data, _subscription;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(isMobileApp && !hasPermission)) {
                _context.next = 5;
                break;
              }
              _data = {
                event: constants.RN_COMM_CONST.OPEN_APP_SETTINGS,
                data: null
              };
              (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.ReactNativeWebView) === null || _window3 === void 0 ? void 0 : _window3.postMessage(JSON.stringify(_data));
              _context.next = 14;
              break;
            case 5:
              setSubscribeLoading(true);
              _context.next = 8;
              return subscribeUserNotification(RNfcmToken);
            case 8:
              _subscription = _context.sent;
              if (!_subscription) {
                _context.next = 13;
                break;
              }
              _context.next = 12;
              return refetchProfile();
            case 12:
              setSubscribeLoading(false);
            case 13:
              setSubscribeLoading(false);
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onUpdateSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onToggleNotification = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return saveNotificationSettings.mutateAsync({
                notification_snoozed: !value
              });
            case 3:
              _context2.next = 5;
              return refetchProfile();
            case 5:
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              Toast.error("Something went wrong. Please retry");
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function onToggleNotification(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (userInfo !== null && userInfo !== void 0 && userInfo.patients_export) {
      Store.update(function (s) {
        var _userInfo$patients_ex, _userInfo$patients_ex2, _userInfo$patients_ex3, _userInfo$patients_ex4;
        s.isExportReady = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex = userInfo.patients_export) === null || _userInfo$patients_ex === void 0 ? void 0 : _userInfo$patients_ex.available;
        s.exportTimestamp = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex2 = userInfo.patients_export) === null || _userInfo$patients_ex2 === void 0 ? void 0 : _userInfo$patients_ex2.timestamp;
        s.downloadProgress = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex3 = userInfo.patients_export) === null || _userInfo$patients_ex3 === void 0 ? void 0 : _userInfo$patients_ex3.progress;
        s.exportGenFailed = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex4 = userInfo.patients_export) === null || _userInfo$patients_ex4 === void 0 ? void 0 : _userInfo$patients_ex4.failed;
      });
    }
  }, [userInfo]);
  var startDownload = function startDownload() {
    if (isExportReady) {
      Store.update(function (s) {
        s.showExportUpdate = true;
      });
    } else if ((downloadProgress === 0 || downloadProgress === 100) && !isStartingDownload) {
      setDownloadExport(true);
      var _url = "patients_export/start_generation/";
      patientsExportService(_url).then(function (response) {
        setDownloadExport(false);
        if (response !== null && response !== void 0 && response.success) {
          Store.update(function (s) {
            s.isExportReady = false;
            s.downloadProgress = 1;
            s.exportGenFailed = false;
          });
        }
      })["catch"](function (resp) {
        setDownloadExport(false);
        Store.update(function (s) {
          s.isExportReady = false;
          s.downloadProgress = 0;
          s.exportGenFailed = true;
        });
      });
    }
  };
  var profileNavigations = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start p-4 bg-gray-700 overflow-hidden rounded-t text-white"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UserIcon, {
      name: get(user, ["name"], "") || get(user, ["preferred_username"], ""),
      className: "h-8 w-8 text-lg"
    })), /*#__PURE__*/React.createElement("div", {
      className: "pl-4 flex flex-col items-start justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-medium text-base break-all"
    }, get(user, ["name"], "") || get(user, ["preferred_username"], "")), /*#__PURE__*/React.createElement("div", {
      className: "text-md text-gray-400 break-all"
    }, get(user, ["email"], "")))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start gap-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faHandshake
    }), /*#__PURE__*/React.createElement("p", null, "Terms of use")),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-6 flex items-center"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_16743_149855)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M18.125 9.5C18.125 6.39453 15.6055 3.875 12.5 3.875C9.39453 3.875 6.875 6.39453 6.875 9.5C6.875 9.98438 7.05078 10.7344 7.47266 11.7344C7.88281 12.7031 8.46484 13.7734 9.13281 14.8555C10.2461 16.6602 11.5352 18.4023 12.5 19.6445C13.4688 18.4023 14.7578 16.6602 15.8672 14.8555C16.5352 13.7734 17.1172 12.7031 17.5273 11.7344C17.9492 10.7344 18.125 9.98438 18.125 9.5ZM20 9.5C20 12.9141 15.4297 18.9922 13.4258 21.5C12.9453 22.0977 12.0547 22.0977 11.5742 21.5C9.57031 18.9922 5 12.9141 5 9.5C5 5.35938 8.35938 2 12.5 2C16.6406 2 20 5.35938 20 9.5ZM13.75 9.5C13.75 9.16848 13.6183 8.85054 13.3839 8.61612C13.1495 8.3817 12.8315 8.25 12.5 8.25C12.1685 8.25 11.8505 8.3817 11.6161 8.61612C11.3817 8.85054 11.25 9.16848 11.25 9.5C11.25 9.83152 11.3817 10.1495 11.6161 10.3839C11.8505 10.6183 12.1685 10.75 12.5 10.75C12.8315 10.75 13.1495 10.6183 13.3839 10.3839C13.6183 10.1495 13.75 9.83152 13.75 9.5ZM9.375 9.5C9.375 8.6712 9.70424 7.87634 10.2903 7.29029C10.8763 6.70424 11.6712 6.375 12.5 6.375C13.3288 6.375 14.1237 6.70424 14.7097 7.29029C15.2958 7.87634 15.625 8.6712 15.625 9.5C15.625 10.3288 15.2958 11.1237 14.7097 11.7097C14.1237 12.2958 13.3288 12.625 12.5 12.625C11.6712 12.625 10.8763 12.2958 10.2903 11.7097C9.70424 11.1237 9.375 10.3288 9.375 9.5Z",
      fill: "#00D0CD"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_16743_149855"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "15",
      height: "20",
      fill: "white",
      transform: "translate(5 2)"
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, get(constants, ["REGION_LABELS", getCurrentRegion()], "global"))),
    onClick: function onClick() {},
    className: "block dark:text-gray-200 text-gray-800 cursor-pointer hover:!bg-gray-800 hover:!text-gray-100"
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-6 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faArrowRightFromBracket,
      size: "lg"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, t("logout_key"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isLogoutOpen = true;
      });
    }
  }];
  var startExportCSV = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _sourceID, _response, _csvFileUrl, _anchorTag;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _sourceID = get(userInfo, ["upload_sources", 0, "uuid"]);
              if (_sourceID) {
                _context3.next = 6;
                break;
              }
              Toast.error("Error while exporting csv!");
              _context3.next = 16;
              break;
            case 6:
              Toast.warning("Generating csv");
              _context3.next = 9;
              return servicesUtils.postService(PDS_EXPORT_CSV_URL, {
                sourceID: _sourceID
              });
            case 9:
              _response = _context3.sent;
              _csvFileUrl = get(_response, ["presigned_seg_url"]);
              _anchorTag = document.createElement("a");
              _anchorTag.href = _csvFileUrl;
              _anchorTag.target = "_blank";
              _anchorTag.click();
              Toast.success("CSV downloaded");
            case 16:
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](0);
              Toast.error("Error while exporting csv!");
            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 18]]);
    }));
    return function startExportCSV() {
      return _ref4.apply(this, arguments);
    };
  }();
  var exportMenu = {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-between",
      onClick: function onClick() {
        //startDownload()
        startExportCSV();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("flex items-center justify-start", {
        "opacity-50": isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady
      })
    }, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M6.875 19.5V4.5C6.875 4.15625 7.15625 3.875 7.5 3.875H13.75V7C13.75 7.69141 14.3086 8.25 15 8.25H18.125V19.5C18.125 19.8438 17.8438 20.125 17.5 20.125H7.5C7.15625 20.125 6.875 19.8438 6.875 19.5ZM7.5 2C6.12109 2 5 3.12109 5 4.5V19.5C5 20.8789 6.12109 22 7.5 22H17.5C18.8789 22 20 20.8789 20 19.5V8.03516C20 7.37109 19.7383 6.73438 19.2695 6.26562L15.7305 2.73047C15.2617 2.26172 14.6289 2 13.9648 2H7.5ZM11.875 12V13.875H9.375V12H11.875ZM9.375 15.125H11.875V17H9.375V15.125ZM13.125 15.125H15.625V17H13.125V15.125ZM12.5 18.25H13.125H15.625C16.3164 18.25 16.875 17.6914 16.875 17V15.125V14.5V13.875V12C16.875 11.3086 16.3164 10.75 15.625 10.75H13.125H12.5H11.875H9.375C8.68359 10.75 8.125 11.3086 8.125 12V13.875V14.5V15.125V17C8.125 17.6914 8.68359 18.25 9.375 18.25H11.875H12.5ZM13.125 13.875V12H15.625V13.875H13.125Z"
    })), /*#__PURE__*/React.createElement("p", {
      className: "ml-3"
    }, "Export data")), exportGenFailed && /*#__PURE__*/React.createElement("div", {
      className: "flex text-md text-red-600 dark:text-red-400 font-normal"
    }, "Failed,try again"), downloadProgress > 0 && !isExportReady && /*#__PURE__*/React.createElement("div", {
      className: "w-6 h-6"
    }, /*#__PURE__*/React.createElement(CircularProgressbar, {
      value: downloadProgress,
      styles: buildStyles({
        rotation: 0.25,
        strokeLinecap: "butt",
        textSize: "24px",
        pathTransitionDuration: 0.5,
        pathColor: "rgba(0, 130, 128)",
        textColor: "#f88",
        trailColor: isDarkMode ? "white" : "#b6aeae",
        backgroundColor: "white"
      })
    }))),
    onClick: function onClick() {}
  };
  var settingsMenu = [
  //{
  //  name: (
  //    <div className="flex p-4 items-center justify-start">
  //      <AwesomeIcon name={faBell} size="lg" className="w-6" />
  //      <div className="flex items-center justify-start ml-3">
  //        {t("setting_notification")}
  //      </div>
  //    </div>
  //  ),
  //  onClick: () =>
  //    Store.update((s) => {
  //      s.isNotificationSettingsOpen = true;
  //    }),
  //},
  {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faUsersMedical,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, "Trial Management")),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isRecistAdminOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faShareNodes,
      size: "xl",
      className: "w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_automated"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isAutomatedSharingOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faUserGroup,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_user"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isUserGroupOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faList,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_worklist"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isSettingsModalOpen = true;
      });
    }
  },
  //{
  //  name: (
  //    <div className="flex p-4 items-center justify-start">
  //      <AwesomeIcon name={faFile} size="lg" className="w-6" />
  //      <div className="flex items-center justify-start ml-3">
  //        {t("setting_report")}
  //      </div>
  //    </div>
  //  ),
  //  onClick: () =>
  //    Store.update((s) => {
  //      s.isReportTemplateOpen = true;
  //    }),
  //},
  {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faUsersMedical,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_workspace"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isWorkspaceOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faNetworkWired,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_connection"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isConnectModalityOpen = true;
      });
    }
  }, exportMenu];
  var addPatientmenu = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleUser,
      size: "lg",
      className: "w-6 mr-3"
    }), t("add_patient")),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isAddPatientOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faFileArrowUp,
      size: "lg",
      className: "w-6 mr-3"
    }), t("add_import_scans")),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.uploadModal = {
          isOpen: true,
          hasCurrentPatient: false
        };
      });
    }
  }];
  var mobileMenu = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faList,
      size: "lg",
      className: "w-6 mr-5"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_worklist"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isSettingsModalOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faBell,
      size: "lg",
      className: "mr-5 w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_notification"))),
    onClick: function onClick() {
      if (isMobile) {
        router.push("/notification-settings");
      } else {
        Store.update(function (s) {
          s.isNotificationSettingsOpen = true;
        });
      }
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faShareNodes,
      size: "xl",
      className: "w-6 mr-5"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_automated"))),
    onClick: function onClick() {
      Store.update(function (s) {
        s.isAutomatedSharingOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faUserGroup,
      size: "lg",
      className: "w-6 mr-5"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_user"))),
    onClick: function onClick() {
      Store.update(function (s) {
        s.isUserGroupOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: classNames("flex p-4 items-center justify-start", {
        hidden: !totalGateway
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, offlineGatewayCount > 0 && /*#__PURE__*/React.createElement("div", {
      className: "absolute border-2 border-gray-800 flex justify-center items-center text-sm rounded-full bg-red-500 right-4 font-medium -top-1 w-5 h-5"
    }, offlineGatewayCount), /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faArrowUpArrowDown,
      size: "lg",
      className: "w-6 mr-5"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_gateway"))),
    onClick: function onClick() {
      if (isMobile) {
        router.push("/gateway-indicator");
      } else {
        Store.update(function (s) {
          s.isGatewayModalOpen = true;
        });
      }
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-6 flex items-center"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_16743_149855)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M18.125 9.5C18.125 6.39453 15.6055 3.875 12.5 3.875C9.39453 3.875 6.875 6.39453 6.875 9.5C6.875 9.98438 7.05078 10.7344 7.47266 11.7344C7.88281 12.7031 8.46484 13.7734 9.13281 14.8555C10.2461 16.6602 11.5352 18.4023 12.5 19.6445C13.4688 18.4023 14.7578 16.6602 15.8672 14.8555C16.5352 13.7734 17.1172 12.7031 17.5273 11.7344C17.9492 10.7344 18.125 9.98438 18.125 9.5ZM20 9.5C20 12.9141 15.4297 18.9922 13.4258 21.5C12.9453 22.0977 12.0547 22.0977 11.5742 21.5C9.57031 18.9922 5 12.9141 5 9.5C5 5.35938 8.35938 2 12.5 2C16.6406 2 20 5.35938 20 9.5ZM13.75 9.5C13.75 9.16848 13.6183 8.85054 13.3839 8.61612C13.1495 8.3817 12.8315 8.25 12.5 8.25C12.1685 8.25 11.8505 8.3817 11.6161 8.61612C11.3817 8.85054 11.25 9.16848 11.25 9.5C11.25 9.83152 11.3817 10.1495 11.6161 10.3839C11.8505 10.6183 12.1685 10.75 12.5 10.75C12.8315 10.75 13.1495 10.6183 13.3839 10.3839C13.6183 10.1495 13.75 9.83152 13.75 9.5ZM9.375 9.5C9.375 8.6712 9.70424 7.87634 10.2903 7.29029C10.8763 6.70424 11.6712 6.375 12.5 6.375C13.3288 6.375 14.1237 6.70424 14.7097 7.29029C15.2958 7.87634 15.625 8.6712 15.625 9.5C15.625 10.3288 15.2958 11.1237 14.7097 11.7097C14.1237 12.2958 13.3288 12.625 12.5 12.625C11.6712 12.625 10.8763 12.2958 10.2903 11.7097C9.70424 11.1237 9.375 10.3288 9.375 9.5Z",
      fill: "#00D0CD"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_16743_149855"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "15",
      height: "20",
      fill: "white",
      transform: "translate(5 2)"
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, get(constants, ["REGION_LABELS", getCurrentRegion()], "global"))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start gap-2"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faHandshake
    }), /*#__PURE__*/React.createElement("p", null, "Terms of use")),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faArrowRightFromBracket,
      size: "lg",
      className: "mr-5 w-6"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, t("logout_key"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isLogoutOpen = true;
      });
    }
  }];
  if (urlAuthToken && !isLoggedIn) {
    var _onClose = function _onClose() {
      Store.update(function (s) {
        s.isGetFullAccessOpen = false;
      });
    };
    var _onOpen = function _onOpen() {
      Store.update(function (s) {
        s.isGetFullAccessOpen = true;
      });
    };
    return /*#__PURE__*/React.createElement("header", {
      className: classNames("flex items-center bg-gray-900 px-5 py-4 border-b border-gray-800", {
        "pt-8": isWebView()
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement(Image, {
      className: "block h-auto w-auto",
      src: "/assets/images/qureLogo.svg",
      alt: "Qure.ai",
      width: "76",
      height: "25"
    }), /*#__PURE__*/React.createElement("div", {
      className: "ml-4 flex items-center"
    }, /*#__PURE__*/React.createElement(Image, {
      className: "block h-auto w-auto",
      src: "/assets/images/pdsLogo.svg",
      alt: "PDS",
      width: "73",
      height: "35"
    }))), /*#__PURE__*/React.createElement("button", {
      className: "bg-teal-500 ml-auto py-3 px-5 rounded-lg",
      onClick: _onOpen
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-gray-200"
    }, t("full_access"))), /*#__PURE__*/React.createElement(Modal, {
      show: isGetFullAccessOpen,
      onClose: _onClose,
      title: "Get Full Access",
      className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
      closeOnClickAway: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-lg text-gray-800 dark:text-gray-200 py-3"
    }, t("add_worklist_signin_access")), /*#__PURE__*/React.createElement("div", {
      className: "text-gray-100 text-base space-x-5"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: _onClose,
      className: "grow-1 px-6 py-4"
    }, t("no_thanks")), /*#__PURE__*/React.createElement(Button, {
      isPrimary: true,
      onClick: function onClick() {
        return redirectToLogin();
      },
      className: "grow-1 px-6 py-4"
    }, t("add_worklist"))))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Transition.Root, {
    show: open,
    as: Fragment
  }, /*#__PURE__*/React.createElement(Dialog, {
    as: "div",
    className: "relative lg:hidden",
    onClose: setOpen
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "transition-opacity ease-linear duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity ease-linear duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-25"
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-50 flex text-gray-200"
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "-translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "-translate-x-full"
  }, /*#__PURE__*/React.createElement(Dialog.Panel, {
    className: "relative flex w-[290px] max-w-[85%] flex-col overflow-y-auto bg-gray-800 pb-12 shadow-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col items-start justify-start p-4 bg-gray-700 overflow-hidden", {
      "pt-9": isWebView()
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UserIcon, {
    name: get(user, ["name"], "") || get(user, ["preferred_username"], ""),
    className: "h-8 w-8 text-lg"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-center mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-base break-all"
  }, get(user, ["name"], "") || get(user, ["preferred_username"], "")), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-400 break-all"
  }, get(user, ["email"], "")))), /*#__PURE__*/React.createElement("div", {
    className: "max-w-3xl"
  }, !hasPermission || !isSubscribed ? /*#__PURE__*/React.createElement("div", {
    className: "bg-yellow-900 text-md p-4 py-5"
  }, isSubscribeLoading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Loader, {
    size: "medium",
    label: "Please wait",
    className: "mr-3",
    containerClassName: "!py-0 flex !flex-row"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "pr-2"
  }, t("notification_modal.no_notifications_setting")), /*#__PURE__*/React.createElement("span", {
    className: "text-yellow-400 font-bold cursor-pointer",
    onClick: onUpdateSubscription
  }, t("notification_modal.update_settings")))) : /*#__PURE__*/React.createElement("div", {
    className: "flex p-4 items-center justify-between border-b border-gray-700"
  }, /*#__PURE__*/React.createElement("div", null, t("notifications_turned_on")), /*#__PURE__*/React.createElement(Toggle, {
    value: isNotificationOn,
    onChange: onToggleNotification,
    disabled: saveNotificationSettings.isLoading || isProfileLoading || isNotificationSubscribing
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex p-4 pt-5 text-md text-gray-500 items-center"
  }, t("menu.settings")), mobileMenu.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "",
      onClick: function onClick() {
        setOpen(false);
        item === null || item === void 0 ? void 0 : item.onClick();
      }
    }, item.name);
  }), !!isRNTestBuild && /*#__PURE__*/React.createElement("div", {
    className: "",
    onClick: function onClick() {
      Store.update(function (s) {
        s.isRNEnvSelectorOpen = true;
      });
      setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex p-4 items-center justify-start"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMobileNotch,
    className: "h-6 w-6 mr-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, "Debug Environment"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start text-sm"
  }, RNSelectedEnv))))))))))), /*#__PURE__*/React.createElement("header", {
    className: classNames("bg-gray-900 shadow-sm lg:static lg:overflow-y-visible h-fit border-b-none sm:border-b border-gray-800", {
      "hidden sm:block": hideMenubar,
      "mt-7": isWebView()
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex sm:justify-between sm:w-full"
  }, !(isNotificationSettings || isGatewayIndicator || isPatientRegistration) && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center sm:hidden inset-y-0"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setOpen(true);
    },
    className: "-mx-2 rounded-md p-5 inline-flex items-center justify-center text-gray-200"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t("open_menu")), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faAlignJustify,
    size: "lg",
    className: "w-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex md:left-0 md:inset-y-0 lg:static xl:col-span-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-shrink-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:flex justify-center items-center ml-4 cursor-pointer"
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "block h-auto w-auto",
    src: "/assets/images/qureLogo.svg",
    alt: "Qure.ai",
    width: "76",
    height: "25"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 flex items-center"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "block h-auto w-auto",
    src: "/assets/images/pdsLogo.svg",
    alt: "PDS",
    width: "73",
    height: "35"
  }))))), (isDashboard || isWorkList) && metabase_enabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 flex items-center ".concat(router.asPath === "/dashboard" ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10 ", "\n                                transition duration-500\n                                hover:bg-teal-500/10 ml-6 px-4")
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/dashboard"
  }, t("dashboard_key"))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 flex items-center ".concat(/patients/g.test(router.asPath) ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10", "\n                              transition duration-500 hover:bg-teal-500/10  px-4")
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/patients"
  }, t("worklist_key")))), isViewerPage && /*#__PURE__*/React.createElement("span", {
    onClick: onBack,
    className: classNames("flex justify-center items-center text-gray-200 cursor-pointer p-5", {
      "ml-4 border-l border-gray-800": !isWorkList && !isNotificationSettings && !isGatewayIndicator
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faAngleLeft,
    className: "ml-3 w-5 mr-3"
  }), t("back_key")), isPatientRegistration && /*#__PURE__*/React.createElement("span", {
    onClick: onBack,
    className: classNames("flex justify-center items-center text-gray-200 cursor-pointer p-5")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "ml-3 w-5 mr-3"
  }), t("button.cancel")))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-white md:space-x-8"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    tooltipContainerStyles: "cursor-pointer",
    tooltipText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Previous Patient")),
    position: "right",
    verticalPosition: "bottom",
    tooltipStyles: "text-sm rounded-6 p-3 px-4 text-gray-100",
    tooltipBg: "bg-gray-700"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: (indexOfCurrentPatient === 0 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1,
    onClick: function onClick() {
      handleChangeButton("prev");
    },
    className: "disabled:opacity-50 hidden md:block"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    className: classNames("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: "items-center text-gray-200 flex"
  }, hasPatientDetails && !isWorkList && !isDashboard && !isNotificationSettings && !isGatewayIndicator && !isPatientRegistration && /*#__PURE__*/React.createElement("span", null, (_activePatientDetail$ = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.name) !== null && _activePatientDetail$ !== void 0 ? _activePatientDetail$ : patient === null || patient === void 0 ? void 0 : patient.name, " |", " ", /*#__PURE__*/React.createElement("span", {
    title: (_activePatientDetail$2 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$2 !== void 0 ? _activePatientDetail$2 : patient === null || patient === void 0 ? void 0 : patient.patientID
  }, (_ref5 = (_activePatientDetail$3 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$3 !== void 0 ? _activePatientDetail$3 : patient === null || patient === void 0 ? void 0 : patient.patientID) === null || _ref5 === void 0 ? void 0 : _ref5.slice(0, 10)))), /*#__PURE__*/React.createElement(Tooltip, {
    tooltipContainerStyles: "cursor-pointer",
    tooltipText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Next Patient")),
    position: "left",
    verticalPosition: "bottom",
    tooltipStyles: "text-sm rounded-6 p-3 px-4 text-gray-100",
    tooltipBg: "bg-gray-700"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: (indexOfCurrentPatient === _patientsUID.length - 1 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1,
    className: "disabled:opacity-50 hidden md:block",
    onClick: function onClick() {
      handleChangeButton("next");
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronRight,
    className: classNames("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  })))), swiftModeEnabled && isViewerPage && /*#__PURE__*/React.createElement("div", {
    className: "border-teal-700 group z-50 relative h-fit my-auto flex items-center border rounded-lg bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-teal-800 py-3 pr-5 pl-2 border-teal-700 border-r rounded-l-lg flex items-center space-x-4"
  }, /*#__PURE__*/React.createElement("svg", {
    onClick: function onClick() {
      setShowSwiftFilter(!showSwiftFilter);
    },
    className: "text-teal-500 dark:text-gray-400 w-6 h-6 cursor-pointer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 4.5C15.0273 4.5 15.75 5.22109 15.75 6.10937C15.75 6.51562 15.5977 6.91016 15.2852 7.20703L11.6523 11.1172V18.2266C11.6523 18.9297 11.1172 19.5 10.4141 19.5C10.1289 19.5 9.91797 19.4258 9.71094 19.2891L6.73047 17.3438C6.32422 17.0547 6.0625 16.5625 6.0625 16.0391V11.1172L2.43047 7.20703C2.15375 6.91016 2 6.51562 2 6.10937C2 5.22109 2.72109 4.5 3.61055 4.5H14.1406ZM7.90234 10.75V15.8711L9.77734 17.1094V10.75C9.77734 10.5117 9.90234 10.2852 10.0625 10.1133L13.5312 6.375H4.2168L7.6875 10.1133C7.84766 10.2852 7.90234 10.5117 7.90234 10.75ZM21.0625 17.3125C21.582 17.3125 22 17.7305 22 18.25C22 18.7695 21.582 19.1875 21.0625 19.1875H15.4375C14.918 19.1875 14.5 18.7695 14.5 18.25C14.5 17.7305 14.918 17.3125 15.4375 17.3125H21.0625ZM14.5 12C14.5 11.4805 14.918 11.0625 15.4375 11.0625H21.0625C21.582 11.0625 22 11.4805 22 12C22 12.5195 21.582 12.9375 21.0625 12.9375H15.4375C14.918 12.9375 14.5 12.5195 14.5 12ZM21.0625 4.8125C21.582 4.8125 22 5.23242 22 5.75C22 6.26953 21.582 6.6875 21.0625 6.6875H17.9375C17.418 6.6875 17 6.26953 17 5.75C17 5.23242 17.418 4.8125 17.9375 4.8125H21.0625Z",
    className: "fill-gray-500 dark:fill-gray-400"
  })), /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-teal-300 "
  }, indexOfCurrentPatient + 1, " of ", count)), /*#__PURE__*/React.createElement("p", {
    className: "text-white font-medium px-5 py-3"
  }, t("swift_report_mode")), /*#__PURE__*/React.createElement("button", {
    title: t("exit_swift_reporting_mode"),
    onClick: function onClick() {
      onBack();
    },
    className: "bg-red-700 invisible group-hover:visible border border-gray-600 rounded-r-lg px-3 py-3"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "w-6 h-6 text-gray-100 stroke-2"
  })), showSwiftFilter && /*#__PURE__*/React.createElement("div", {
    className: "absolute translate-y-[75%] z-50 bg-gray-800 border text-gray-200 gap-4 rounded-xl border-gray-700 flex flex-wrap p-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("negative")), /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("screened_by_qure")), /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, "CXR"))), /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex sm:items-center sm:justify-end xl:col-span-4"
  }, isWorkList && /*#__PURE__*/React.createElement("button", {
    className: classNames("inline-flex items-center justify-center text-base font-medium rounded-6 text-gray-100 !px-5 !py-3 mr-3 bg-teal-800 hover:bg-teal-900"),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.uploadModal = {
          isOpen: true,
          hasCurrentPatient: false
        };
      });
    }
  }, t("add_key"), " "), totalGateway > 0 && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: [{
      name: /*#__PURE__*/React.createElement("div", {
        className: "flex p-4 items-center justify-start hover:!bg-teal-500 dark:hover:!bg-teal-800 border-t border-gray-300 dark:border-gray-500/40"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCircleInfo,
        size: "lg",
        className: "w-6"
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-start ml-3"
      }, t("more_information"))),
      onClick: function onClick() {
        return Store.update(function (s) {
          s.isGatewayModalOpen = true;
        });
      }
    }],
    menuItemClassName: "z-50 w-80",
    childrenContent: /*#__PURE__*/React.createElement(GatewayDropdown, null),
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", {
        className: "relative"
      }, offlineGatewayCount > 0 && /*#__PURE__*/React.createElement("div", {
        className: "absolute border-2 border-gray-900 flex justify-center items-center text-sm rounded-full bg-red-500 right-4 font-medium top-3 w-5 h-5"
      }, offlineGatewayCount), /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faArrowUpArrowDown,
        size: "lg",
        className: "m-5"
      }));
    }
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    options: settingsMenu,
    menuItemClassName: "z-50",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faGear,
        size: "lg",
        className: "m-5"
      });
    }
  }), isLoggedIn && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: profileNavigations,
    menuItemClassName: "z-50",
    Icon: function Icon(_ref6) {
      var open = _ref6.open;
      return /*#__PURE__*/React.createElement(UserIcon, {
        className: classNames("h-7 w-7 m-4 group-hover:bg-gray-700", {
          "!bg-gray-700": open
        }),
        name: get(user, ["name"], "") || get(user, ["preferred_username"], "")
      });
    }
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      router.push("/gateway-indicator");
    },
    className: classNames("relative text-white mx-5 sm:hidden flex justify-end items-center", {
      hidden: !offlineGatewayCount || !isWorkList
    })
  }, offlineGatewayCount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "absolute border-2 border-gray-900 flex justify-center items-center text-sm rounded-full bg-red-500 -right-[5px] font-medium -top-[6px] w-[17px] h-[17px]"
  }, offlineGatewayCount), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowUpArrowDown,
    className: "w-6"
  })))), showTermsAndConditionsModal && /*#__PURE__*/React.createElement(TermsAndConditionsModal, {
    onClose: function onClose() {
      setShowTermsAndConditionsModal(false);
    }
    // closeOnClickAway
    ,
    mode: "readonly"
  })));
};
export default Menubar;